// extracted by mini-css-extract-plugin
export var singleBoxDescription = "c-and-cpp-development-module--single-box-description--q8A5y";
export var whyUseTechnologies = "c-and-cpp-development-module--why-use-technologies--f74px";